import React, { useState, useEffect } from 'react';
import '../styles/ReportesEspeciales.css';

const ReportesEspeciales = () => {
  const [reportes, setReportes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/reportes-especiales.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error('No se pudo cargar el archivo de reportes');
        }
        return response.json();
      })
      .then(data => {
        setReportes(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error al cargar reportes:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (error) {
    return (
      <div className="presentation-page pt-16">
        <header className="reportes-hero-section">
          <div className="reportes-hero-content">
            <div className="reportes-hero-container">
              <div className="reportes-hero-card">
                <div className="reportes-hero-grid">
                  <div className="reportes-hero-left">
                    <h1 className="reportes-hero-title">
                      <span className="reportes-hero-title-gradient">Reportes</span> Especiales
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="reportes-content-section">
          <div className="container">
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p style={{ color: '#d32f2f', fontSize: '16px' }}>
                Error al cargar los reportes: {error}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="presentation-page pt-16">
        <header className="reportes-hero-section">
          <div className="reportes-hero-content">
            <div className="reportes-hero-container">
              <div className="reportes-hero-card">
                <div className="reportes-hero-grid">
                  <div className="reportes-hero-left">
                    <h1 className="reportes-hero-title">
                      <span className="reportes-hero-title-gradient">Reportes</span> Especiales
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section className="reportes-content-section">
          <div className="container">
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Cargando reportes...</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  const sortedReportes = [...reportes].sort((a, b) => {
    const dateA = new Date(a.fecha.replace(' de ', '-').replace('de ', ''));
    const dateB = new Date(b.fecha.replace(' de ', '-').replace('de ', ''));
    return dateB - dateA;
  });

  const isSearching = searchQuery.trim().length > 0;

  const filteredReportes = isSearching
    ? sortedReportes.filter(r =>
        r.titulo.toLowerCase().includes(searchQuery.trim().toLowerCase())
      )
    : sortedReportes;

  const ReporteItem = ({ reporte }) => (
    <div className="pb-2 reportes-item">
      <a href={reporte.url} target="_blank" rel="noopener noreferrer">
        <div className="reportes-icon">
          <svg className="text-info" width="25px" height="25px" viewBox="0 0 52 35" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>sound-wave</title>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g transform="translate(-2015.000000, -596.000000)" fill="#FFFFFF" fillRule="nonzero">
                <g transform="translate(1716.000000, 291.000000)">
                  <g id="sound-wave" transform="translate(299.000000, 305.000000)">
                    <path className="color-foreground" d="M15.2941176,30.5882353 C14.6024837,30.5882353 13.9754248,30.1667974 13.7154248,29.5210458 L8.11777778,15.5269281 L6.51189542,17.9366013 C6.19581699,18.4090196 5.66562092,18.6928105 5.09803922,18.6928105 L0,18.6928105 L0,15.2941176 L4.18888889,15.2941176 L7.08287582,10.9522876 C7.43294118,10.4288889 8.03281046,10.1467974 8.67346405,10.2045752 C9.30052288,10.2708497 9.84261438,10.6769935 10.0754248,11.263268 L15.0969935,23.8214379 L22.1696732,1.19294118 C22.3905882,0.482614379 23.0465359,0 23.7908497,0 C23.792549,0 23.792549,0 23.7942484,0 C24.5385621,0.00169934641 25.1962092,0.487712418 25.4154248,1.19973856 L31.2305882,20.1015686 L34.3267974,15.9738562 C34.6462745,15.5456209 35.1509804,15.2941176 35.6862745,15.2941176 L40.7843137,15.2941176 L40.7843137,18.6928105 L36.5359477,18.6928105 L31.9477124,24.8104575 C31.5653595,25.3202614 30.9298039,25.5717647 30.2959477,25.4647059 C29.6671895,25.3542484 29.1522876,24.9005229 28.9636601,24.2904575 L23.7772549,7.43803922 L16.9152941,29.3952941 C16.7011765,30.0818301 16.0792157,30.5593464 15.3603922,30.5865359 C15.3366013,30.5882353 15.3162092,30.5882353 15.2941176,30.5882353 Z"></path>
                    <path className="color-background" d="M26.5098039,34.6666667 C25.8181699,34.6666667 25.1911111,34.2452288 24.9311111,33.5994771 L19.3334641,19.6053595 L17.7275817,22.0150327 C17.4115033,22.487451 16.8813072,22.7712418 16.3137255,22.7712418 L11.2156863,22.7712418 L11.2156863,19.372549 L15.4045752,19.372549 L18.2985621,15.030719 C18.6486275,14.5073203 19.2484967,14.2252288 19.8891503,14.2830065 C20.5162092,14.349281 21.0583007,14.7554248 21.2911111,15.3416993 L26.3126797,27.8998693 L33.3853595,5.27137255 C33.6062745,4.56104575 34.2622222,4.07843137 35.0065359,4.07843137 C35.0082353,4.07843137 35.0082353,4.07843137 35.0099346,4.07843137 C35.7542484,4.08013072 36.4118954,4.56614379 36.6311111,5.27816993 L42.4462745,24.18 L45.5424837,20.0522876 C45.8619608,19.6240523 46.3666667,19.372549 46.9019608,19.372549 L52,19.372549 L52,22.7712418 L47.751634,22.7712418 L43.1633987,28.8888889 C42.7810458,29.3986928 42.1454902,29.6501961 41.511634,29.5431373 C40.8828758,29.4326797 40.3679739,28.9789542 40.1793464,28.3688889 L34.9929412,11.5164706 L28.1309804,33.4737255 C27.9168627,34.1602614 27.294902,34.6377778 26.5760784,34.6649673 C26.5522876,34.6666667 26.5318954,34.6666667 26.5098039,34.6666667 Z" id="Path-Copy" opacity="0.604957217"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div className="reportes-description ps-3">
          <p className="mb-0">
            {reporte.titulo}
          </p>
        </div>
      </a>
    </div>
  );

  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="reportes-hero-section">
        <div className="reportes-hero-content">
          <div className="reportes-hero-container">
            <div className="reportes-hero-card">
              <div className="reportes-hero-grid">
                <div className="reportes-hero-left">
                  <h1 className="reportes-hero-title">
                    <span className="reportes-hero-title-gradient">Reportes</span> Especiales de
                    <span className="reportes-hero-title-gradient"> RESNOM</span>
                  </h1>
                </div>
                <div className="reportes-hero-right">
                  <p className="reportes-hero-description">
                    Accede a los reportes especiales detallados de eventos sísmicos significativos registrados por la Red Sísmica del Noroeste de México. Información técnica y análisis especializado.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Reportes Especiales Section */}
      <section className="reportes-content-section py-sm-7 py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 mt-lg-0 mt-5 ps-lg-0 ps-0">

              {/* Barra de búsqueda */}
              <div className="reportes-search-wrapper">
                <div className="reportes-search-input-wrapper">
                  <i className="fas fa-search reportes-search-icon"></i>
                  <input
                    type="text"
                    className="reportes-search-input"
                    placeholder="Buscar por título, ubicación, año…"
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                  />
                  {searchQuery && (
                    <button
                      className="reportes-search-clear"
                      onClick={() => setSearchQuery('')}
                      aria-label="Limpiar búsqueda"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
                {isSearching && (
                  <p className="reportes-search-count">
                    {filteredReportes.length > 0
                      ? `${filteredReportes.length} de ${sortedReportes.length} reportes`
                      : `Sin resultados para "${searchQuery}"`}
                  </p>
                )}
              </div>

              {/* Lista filtrada */}
              {filteredReportes.length > 0 ? (
                filteredReportes.map((reporte) => (
                  <ReporteItem key={reporte.id} reporte={reporte} />
                ))
              ) : (
                isSearching && (
                  <div className="reportes-no-results">
                    <i className="fas fa-search"></i>
                    <p>No se encontraron reportes para "<strong>{searchQuery}</strong>"</p>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReportesEspeciales;
